import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  Col,
  Container,
  Dropdown,
  Image,
  Row,
} from "react-bootstrap";
import BreadcrumbSection from "components/BreadcrumbSection";
import IMAGES from "constants/images";
import { Icon } from "@iconify/react";
import VendorSidebar from "inc/VendorSidebar";
import { getReviewAllDispute } from "api/ReviewService";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "context/UserContext";
import DisputeCard from "./DisputeCard";
import { Sentry } from "react-activity";
import Loader from "components/Loader";

const sortOptions = [
  { value: "mostRecent", label: "Most Recent" },
  { value: "weekly", label: "Weekly" },
  { value: "monthly", label: "Monthly" },
  { value: "yearly", label: "Yearly" },
];

const SortDropdown = ({ selectedOption, setSelectedOption }) => {
  return (
    <Dropdown align="start">
      <Dropdown.Toggle
        variant="light"
        className="d-flex align-items-center rounded-pill px-3"
      >
        <Icon icon="solar:sort-linear" fontSize={19} className="me-2" />
        <span className="iconFull header_profile1  ms-2">{selectedOption.label}</span>
 

      </Dropdown.Toggle>

      <Dropdown.Menu>
        {sortOptions.map((option, index) => (
          <Dropdown.Item key={index} onClick={() => setSelectedOption(option)}>
            {option.label}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

const DisputeManagement = () => {
  const [showFollowers, setShowFollowers] = useState(false);
  const [selectedOption, setSelectedOption] = useState(sortOptions[0]);
  const [uiLoading, setUiLoading] = useState(true);

  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);
  const limit = 10;
  const location = useLocation();
  // const productId = location?.state?.productId || "";
  const { user } = useAuth();
  const userId = user ? user._id : "";
  const fetchDispute = async () => {
    try {
      const res = await getReviewAllDispute({
        dateRange: selectedOption.value,
        userId,
        limit,
        page,
      }); // API call
      if (res.success) {
        setData(res.body.data);
      }
      setUiLoading(false)

    } catch (error) {
      setUiLoading(false)

      console.error("Error fetching reviews:", error);
    } finally {
      setUiLoading(false)
      // setLoading(false);
    }
  };

  useEffect(() => {
    fetchDispute();
  }, [page, selectedOption]);
  if(uiLoading){
    return (<div
      className="d-flex justify-content-center align-items-center "
      style={{ minHeight: "50vh" }}
    >
      <Sentry color="#e91515" size={40} speed={1} animating={true} />
      {/* <Loader  style={{width: 100, height: 100}} /> */}
    </div>)
      }
  return (
    <Col lg={12} xl={12}>
      <div className="profile_details_style mb-4 header_profile3">
        <h3>Dispute Management</h3>
        <SortDropdown
          selectedOption={selectedOption}
          setSelectedOption={setSelectedOption}
        />
      </div>
      <div className="profile_details_style mb-3 header_profile2  d-flex  justify-content-between ">
        <div className="d-flex align-items-center">
      <Icon icon="mdi:arrow-left" style={{fontSize: "24px"}} className="me-4" onClick={() => navigate("/vendor/my-profile")}/>
      <h3 className="mb-0">Dispute Management</h3>
      </div>
      <SortDropdown
          selectedOption={selectedOption}
          setSelectedOption={setSelectedOption}
        />
      </div>
      {data.length > 0 ? (
        data?.map((dispute) => {
          return (
            <DisputeCard
              key={dispute._id}
              dispute={dispute}
              disputeId={dispute._id}
              userId={userId}
              fetchData={() => fetchDispute()}
            />
          );
        })
      ) : (
        <Col xs={12}>
          <div className="text-center py-5">
            <Image
              src={IMAGES.emptyState}
              alt=""
              height="300px"
              width="300px"
              className="mb-4"
              // className="imgUser"
            />
            <p className="text-center text-muted">No dispute found.</p>
          </div>
        </Col>
      )}
    </Col>
  );
};

export default DisputeManagement;
